import { render, staticRenderFns } from "./PzSimulatorsTemplate.vue?vue&type=template&id=771bc598&scoped=true"
import script from "./PzSimulatorsTemplate.vue?vue&type=script&lang=js"
export * from "./PzSimulatorsTemplate.vue?vue&type=script&lang=js"
import style0 from "./PzSimulatorsTemplate.vue?vue&type=style&index=0&id=771bc598&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771bc598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771bc598')) {
      api.createRecord('771bc598', component.options)
    } else {
      api.reload('771bc598', component.options)
    }
    module.hot.accept("./PzSimulatorsTemplate.vue?vue&type=template&id=771bc598&scoped=true", function () {
      api.rerender('771bc598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Templates/PzSimulatorsTemplate.vue"
export default component.exports